var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { AuthStatus, CXoneAuth } from '@nice-devone/auth-sdk';
import { useNicStore } from 'stores/nic/stores/nicStore';
import { loadWebRtcScript } from 'stores/nic/services/nicService';
import { useNicService } from 'stores/nic/useNicService';
import logger from 'utils/logger';
/**
 * Loads the WebRTC script and starts the engagement as soon as a valid token
 * exists. Runs once for the lifetime of the window, so the token may still be
 * absent on mount and arrive later — returning from the NIC auth redirect, or on
 * a silent refresh — hence the auth subscription. Without it, `isInitialized`
 * stays false and the header keeps showing "Click to authenticate" until a full
 * page reload.
 */
export var useInitializeWithScript = function () {
    var initEngagement = useNicService().initEngagement;
    useEffect(function () {
        var isStale = false;
        var initializeWithScript = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isTokenValid, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadWebRtcScript()];
                    case 1:
                        _a.sent();
                        if (isStale)
                            return [2 /*return*/];
                        isTokenValid = CXoneAuth.instance.getAuthState().isTokenValid;
                        if (isTokenValid) {
                            initEngagement();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.logError('Failed to load WebRTC script in useInitializeWithScript.ts', {}, error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        initializeWithScript();
        var subscription = CXoneAuth.instance.onAuthStatusChange.subscribe(function (_a) {
            var status = _a.status;
            var isAuthenticated = status === AuthStatus.AUTHENTICATED ||
                status === AuthStatus.REFRESH_TOKEN_SUCCESS;
            if (!isAuthenticated || isStale)
                return;
            if (useNicStore.getState().isInitialized)
                return;
            initializeWithScript();
        });
        return function () {
            isStale = true;
            subscription.unsubscribe();
        };
    }, [initEngagement]);
};
